module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1526-54c8e5cc7f82aa88edb86366172c125e.png";